var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M20,17c0,1.657-1.343,3-3,3H3c-1.657,0-3-1.343-3-3V3c0-1.657,1.343-3,3-3h14c1.657,0,3,1.343,3,3V17z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 4.887,
    y: 2.5,
    width: 10.227,
    height: 15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BD9C2F",
    d: "M10.854,5.662l-0.847-3.148V2.5l-0.003,0.006L10.003,2.5v0.013L9.155,5.662l0.609,0.001l0.24-0.95 l0.243,0.95L10.854,5.662z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD9C2F",
    d: "M12.978,14.623h-0.662h-2.164h-0.098H9.945H9.847H7.684H7.021v0.002l-2.134,2.147L4.953,17.5l1.834-1.867 h0.661h2.398h0.099h0.108h0.098h2.399h0.662l1.834,1.867l0.066-0.728L12.978,14.623z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD9C2F",
    d: "M14.556,15.347l0.066-0.728l-2.146-2.153h-1.566h-0.55h-0.1H9.738H9.64H9.089H7.536H7.522l-2.141,2.153 l0.067,0.728l1.839-1.871h1.565H9.64h0.099h0.521h0.1h0.785h1.566L14.556,15.347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD9C2F",
    d: "M14.054,13.182l0.066-0.728l-2.146-2.153h-1.064h-0.55h-0.1H9.738H9.64H9.089H8.054H8.04L5.9,12.454 l0.065,0.728l1.839-1.871h1.049H9.64h0.099h0.521h0.1h0.784h1.065L14.054,13.182z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD9C2F",
    d: "M13.555,11.029l0.066-0.727l-2.146-2.154h-0.565h-0.55h-0.099H9.738h-0.1h-0.55H8.545H8.531l-2.141,2.154 l0.066,0.727l1.839-1.87h0.558h0.785h0.1h0.522h0.099h0.785h0.565L13.555,11.029z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD9C2F",
    d: "M13.043,8.873l0.066-0.728l-2.146-2.153h-0.055h-0.55h-0.1H9.737H9.641H9.089H9.041H9.028L6.888,8.145 l0.066,0.728l1.839-1.871h0.061h0.787h0.097h0.522h0.1h0.785h0.054L13.043,8.873z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDown);
export default __webpack_public_path__ + "static/media/appDown.d1a78903c1c4f4f67de7ecde0938edac.svg";
export { ForwardRef as ReactComponent };